// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @components
import { AggregatorDepositBox } from 'components/aggregator/aggregatorBoxes/aggregatorDepositBox/aggregatorDepositBox';
import { AggregatorGenericView } from './aggregatorGenericView/aggregatorGenericView';

// @constants
import { DEPOSITS } from 'constants/aggregator/products';
const {
  AGGREGATOR_NEW_FEATURES,
  NOT_ALLOWED_TINK_AGGREGATOR,
} = require('constants/flagBasedFeatures');

class AggregatorDepositsView extends React.PureComponent {
  getProductComponent = (product) => {
    const { immFlagBasedFeatures } = this.props;
    const AGGREGATOR_V2 = immFlagBasedFeatures.get(AGGREGATOR_NEW_FEATURES);

    const id = product.get('id');
    const alias = product.get('alias');
    const balance = product.get('balance');
    const startDate = product.get('startDate');
    const endDate = product.get('endDate');
    const tax = product.get(AGGREGATOR_V2 ? 'interestRate' : 'tax');
    const account = product.get(AGGREGATOR_V2 ? 'accountNumber' : 'account');

    return (
      product && (
        <AggregatorDepositBox
          id={id}
          alias={alias}
          balance={balance}
          startDate={startDate}
          endDate={endDate}
          tax={tax}
          account={account}
        />
      )
    );
  };

  render() {
    const { immFlagBasedFeatures } = this.props;

    const isTinkAggregator = immFlagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    return (
      <AggregatorGenericView
        hasDetails={false}
        productType={DEPOSITS}
        getProductComponent={this.getProductComponent}
        isTinkAggregator={isTinkAggregator}
      />
    );
  }
}

AggregatorDepositsView.propTypes = {
  immFlagBasedFeatures: PropTypes.object,
};

export default connect(
  state => ({
    immFlagBasedFeatures: state.flagBasedFeatures,
  }),
  null
)(AggregatorDepositsView);
